/**
 * Reset page to the top
 * @function
 */
const scrollToTop = () => {
  window.scrollTo(0, 0);
};

export { scrollToTop };
